import NavItem from "./NavItem";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import GroupIcon from "@mui/icons-material/Group";
import StoreIcon from "@mui/icons-material/Store";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BarChartIcon from "@mui/icons-material/BarChart";
import CalendarIcon from "@mui/icons-material/CalendarMonth";
import AbsenceIcon from "@mui/icons-material/EventBusy";
import AssignmentInd from "@mui/icons-material/AssignmentInd";
import ReviewIcon from "@mui/icons-material/FindInPage";
import { useAuthContext } from "features/auth/AuthContext";
import { UserRole } from "features/auth/types/user";
import SettingsIcon from "@mui/icons-material/Settings";

type MenuItemsProps = { showTooltips?: boolean; onClickItem?: () => void };

const MenuItems: React.FC<MenuItemsProps> = (props) => {
  const { showTooltips, onClickItem } = props;
  const { user, hasRole } = useAuthContext();

  if (hasRole([UserRole.EXTERNAL_INSTALLER])) {
    return (
      <NavItem
        to="/assigned-orders"
        text="Mina ordrar"
        icon={<AssignmentInd />}
        tooltip={showTooltips && "Mina ordrar"}
        onClick={onClickItem}
      />
    );
  }

  return (
    <>
      {/* All employee pages */}
      <NavItem
        to="/dashboard"
        text="Dashboard"
        icon={<DashboardIcon />}
        tooltip={showTooltips && "Dashboard"}
        onClick={onClickItem}
      />

      <NavItem
        to="/absence"
        text="Frånvaro"
        icon={<AbsenceIcon />}
        tooltip={showTooltips && "Frånvaro"}
        onClick={onClickItem}
      />

      <NavItem
        to="/orders"
        text="Ordrar"
        icon={<PlaylistAddCheckIcon />}
        tooltip={showTooltips && "Ordrar"}
        onClick={onClickItem}
      />

      {(hasRole([UserRole.ADMIN]) || user?.isOrderReviewer) && (
        <NavItem
          to="/order-review"
          text="Ordergranskning"
          icon={<ReviewIcon />}
          tooltip={showTooltips && "Ordergranskning"}
          onClick={onClickItem}
        />
      )}

      {/* Internal installer pages */}
      {hasRole([UserRole.INTERNAL_INSTALLER]) && (
        <NavItem
          to="/bookings"
          text="Bokningar"
          icon={<CalendarIcon />}
          tooltip={showTooltips && "Bokningar"}
          onClick={onClickItem}
        />
      )}

      {/* Payroll pages */}
      {hasRole([UserRole.ADMIN, UserRole.PAYROLL]) && (
        <NavItem
          to="/reports"
          text="Tidrapporter"
          icon={<AccessTimeIcon />}
          tooltip={showTooltips && "Tidrapporter"}
          onClick={onClickItem}
        />
      )}

      {/* Useradmin pages */}
      {hasRole([UserRole.ADMIN, UserRole.USER_ADMIN]) && (
        <>
          <NavItem
            to="/users"
            text="Användare"
            icon={<GroupIcon />}
            tooltip={showTooltips && "Användare"}
            onClick={onClickItem}
          />

          <NavItem
            to="/companies"
            text="Underentreprenörer"
            icon={<StoreIcon />}
            tooltip={showTooltips && "Underentreprenörer"}
            onClick={onClickItem}
          />

          <NavItem
            to="/installer-statistics"
            text="Statistik"
            icon={<BarChartIcon />}
            tooltip={showTooltips && "Statistik"}
            onClick={onClickItem}
          />
        </>
      )}

      {/* Admin pages */}
      {hasRole([UserRole.ADMIN]) && (
        <NavItem
          to="/settings"
          text="Inställningar"
          icon={<SettingsIcon />}
          tooltip={showTooltips && "Inställningar"}
          onClick={onClickItem}
        />
      )}
    </>
  );
};

export default MenuItems;
